import { useNavigate } from "react-router";
import SimpleFrame from "../../components/simple";
import { useContext } from "react";
import { DataContext } from "../../context/dataProvider";
import styles from './styles.module.css';

function BuySuccessPage() {
  const context = useContext(DataContext);
  const navigation = useNavigate();

  const goHome = () => {
    navigation('/');
  }

  if (!context) {
    return null;
  }
  const subscriptionEndDate = context.user?.userServer?.subscriptionEndDate;
  const endDateStr = subscriptionEndDate
    ? new Date(subscriptionEndDate).toLocaleDateString('ru-RU')
    : '';
  
  return (
    <div className="buy-success">
      <div className={styles.backgroundContainer}>
          <img src="/images/succes-background.png" alt=""/>
        </div>
        <SimpleFrame
          title="Подписка оплачена"
          subtitle={`Действует до ${endDateStr}`}
          buttonLabel="Вернуться на главную"
          handleClick={() => goHome()}
        />
    </div>
  );
}

export default BuySuccessPage;